import { type FC } from "react";
import { IconType } from "../../common/components/icon/IconType";
import { Icon } from "../../common/components/icon/Icon";
import classNames from "classnames";

import { type IconSize } from "../../common/components/icon/IconSize";
import { PopperTooltip } from "../../common/components/Tooltip";
import { useTranslation } from "react-i18next";
import { URL_PREFERRED_PRODUCTS } from "~/utils/url/staticUrls";
import { ArrowLink } from "~/common/components/Link";
import { userIsCustomer } from "~/utils/roles";

interface ProductPreferredIndicatorProps {
  className?: string;
  side?: "left" | "right" | "bottom";
  iconSize?: IconSize;
}

const ProductPreferredIndicator: FC<ProductPreferredIndicatorProps> = (props) => {
  const { className, side = "left", iconSize } = props;
  const isCustomer = userIsCustomer();

  const { t } = useTranslation();

  return (
    <PopperTooltip
      className={classNames("scha__preferred__popup", className)}
      innerClassName={"scha__preferred__popup__inner"}
      tooltipContent={
        isCustomer ? (
          <ArrowLink className={"f-no-wrap"} href={URL_PREFERRED_PRODUCTS}>
            {t("product.isPreferred")}
          </ArrowLink>
        ) : (
          t("product.isPreferred")
        )
      }
      placement={side}
    >
      <Icon className="f-green" type={IconType.Star} size={iconSize} data-test-id={"product-is-preferred"} />
    </PopperTooltip>
  );
};

export default ProductPreferredIndicator;
